import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cardView",
  "use": "icon-cardView-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cardView\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.964355 1.95117H15.042V2.95117H0.964355V1.95117ZM0.964355 13.6824H15.042V14.6824H0.964355V13.6824ZM2.3783 6.84427H13.6278V9.79H2.3783V6.84427ZM1.3783 5.84427H2.3783H13.6278H14.6278V6.84427V9.79V10.79H13.6278H2.3783H1.3783V9.79V6.84427V5.84427Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol